export default __webpack_public_path__ + "static/media/HomeBanner5.c9dbd773.jpg";